export const AppTheme = {
    PRIMARY_COLOR: "#7A4186",
    PRIMARY_COLOR_LIGHT: "#EAE7F4",
    PRIMARY_COLOR_DARK: "#5D43C3",
    WHITE: "#FFFFFF",
    MUTED_LIGHT: "#F9F9F9",
    MUTED: "#E0DBF4",
    BLACK: "#000000",
    RESET_BUTTON_COLOR: "#E2E2E2"
}

// Font size for @mui/x-data-grid data table
export const MuiDataGridFontSize = "12px"

// Style for @mui/x-data-grid data table
export const MuiDataGridStyle = {
  borderRadius: "8px",
  "& .MuiDataGrid-columnHeader": {
    backgroundColor: "rgba(224, 224, 224, 0.4)",
    fontSize: MuiDataGridFontSize,
  },
  "& .MuiDataGrid-cell": {
    fontSize: MuiDataGridFontSize, // Adjust cell font size globally
  },
  "& .MuiTablePagination-root, & .MuiTablePagination-caption": {
    fontSize: MuiDataGridFontSize,
  },
  "& .MuiTablePagination-selectLabel": {
    fontSize: MuiDataGridFontSize,
  },
  "& .MuiTablePagination-displayedRows": {
    fontSize: MuiDataGridFontSize,
  },
  "& .MuiDataGrid-row:hover": {
    backgroundColor: "transparent !important",
  },
  "& .MuiDataGrid-scrollbar": {
    zIndex: 1,
  }
};